import { FC, useMemo } from 'react'
import { FilterSection } from '@/network/graphql.g'
import useTranslation from 'next-translate/useTranslation'
import MobileFilterGridItem, {
  MobileFilterItemType
} from './mobileFilterGridItem'
import { sortBoostManufacturers } from '@/components/organisms/filter/manufacturerDesktopFilter'

type FilterManufacturersSlidePageProps = {
  manufacturers: FilterSection[]
  initialSelections: string[]
  updatePendingFilter: (ids: string[]) => void
}

const FilterManufacturersSlidePage: FC<FilterManufacturersSlidePageProps> = ({
  manufacturers,
  initialSelections,
  updatePendingFilter
}) => {
  const { t } = useTranslation('common')

  const items: MobileFilterItemType[] = useMemo(() => {
    const sortedSections = [...manufacturers].sort((a, b) => {
      if (a.id === sortBoostManufacturers.topPosition) {
        return -1
      }
      if (b.id === sortBoostManufacturers.topPosition) {
        return 1
      }
      if (a.id === sortBoostManufacturers.bottomPosition) {
        return 1
      }
      if (b.id === sortBoostManufacturers.bottomPosition) {
        return -1
      }
      return 0
    })

    return sortedSections.flatMap((section) => {
      const sectionItems = section.items.map((i) => ({
        id: i.id,
        title: i.title,
        count: i.count
      }))

      return sectionItems.sort((a, b) => {
        const isASelected = initialSelections.includes(a.id)
        const isBSelected = initialSelections.includes(b.id)

        if (isASelected === isBSelected) {
          return 0
        }
        return isASelected ? -1 : 1
      })
    })
  }, [manufacturers, initialSelections])

  return (
    <MobileFilterGridItem
      items={items}
      selectedIds={initialSelections}
      onSelectionChange={updatePendingFilter}
      withSearch={true}
      searchPlaceholder={t('Category.Filter.manufacturerSearchPlaceholder')}
    />
  )
}

export default FilterManufacturersSlidePage
